import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';
import {ArtisticObjectListing} from '../../admin/artisticobjects/types/ArtisticObject';
import {StringTranslations} from '../../common/types/StringTranslations';

export interface CollectionDto {
  readonly id: string;
  readonly title: StringTranslations;
  readonly subtitle?: StringTranslations;
  readonly description?: StringTranslations;
  readonly personal: boolean;
  readonly published: boolean;
  readonly favourite: boolean;
}

export interface CollectionItemDto {
  readonly id: string;
  readonly artisticObject: ArtisticObjectListing;
}

class CollectionsService {
  public async getAllCollections(): Promise<CollectionDto[]> {
    return handleError(
      () => httpClient.get<CollectionDto[]>('/collections'),
      'Error fetching collections:',
      () => []
    );
  }

  public async getCollection(id: string): Promise<CollectionDto> {
    return handleError(
      () => httpClient.get<CollectionDto>(`/collections/${id}`),
      'Error fetching collection:'
    );
  }

  public async getCollectionItems(collectionId: string): Promise<CollectionItemDto[]> {
    return handleError(
      () => httpClient.get<CollectionItemDto[]>(`/collections/${collectionId}/items`),
      'Error fetching collection items:',
      () => []
    );
  }
}

const collectionsService = new CollectionsService();
export default collectionsService;

